<template>
    <div>
        <close-requests></close-requests>

        <alerts :_success="success" :_error="error"></alerts>

        <div v-if="loading" class="d-flex mb-3">
            <div v-for="i in 4" :key="i" class="flex-fill shadow-sm rounded mr-2 p-2 text-center bg-white">
                <h1 class="font-weight-bold mt-0"><img src="../assets/loader.gif"></h1>
            </div>
        </div>

        <div v-else class="d-flex flex-wrap mb-3 dashboard">
            <div class="flex-fill bg-white border rounded-lg shadow-sm p-3">
                <div class="d-flex">
                    <div class="rounded-circle p-2 mr-2">
                        <ion-icon name="notifications-outline" class="text-muted" style="font-size: 50px"></ion-icon>
                    </div>
                    <router-link to="/notifications" class="text-dark">
                        <small class="font-weight-bold">NOTIFICATIONS</small>
                        <h1 class="font-weight-bold font">{{ stats.notifications }}</h1>
                    </router-link>
                </div>
            </div>

            <div class="flex-fill bg-white border rounded-lg p-3">
                <div class="d-flex">
                    <div class="rounded-circle p-2 mr-2">
                        <!-- <img src="../assets/dash/pending.png"> -->
                        <ion-icon name="filter-circle-outline" class="text-muted" style="font-size: 50px"></ion-icon>
                    </div>
                    <router-link to="/requests?status=pending"  class="text-dark">
                        <small class="font-weight-bold">PENDING REQUESTS</small>
                        <h1 class="font-weight-bold font">{{ stats.pending_requests }}</h1>
                    </router-link>
                </div>
            </div>

            <div class="flex-fill bg-white border rounded-lg p-3">
                <div class="d-flex">
                    <div class="rounded-circle bg- p-2 mr-2">
                        <!-- <img src="../assets/dash/tick.png"> -->
                        <ion-icon name="checkmark-done-circle-outline" class="text-muted"
                                  style="font-size: 50px"></ion-icon>
                    </div>
                    <router-link to="/requests?status=approved" class="text-dark">
                        <small class="font-weight-bold">APPROVED REQUESTS</small>
                        <h1 class="font-weight-bold font">{{ stats.approved_requests }}</h1>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="p-4 border mb-3 sh bg-white rounded-lg">
            <h4 class="font-weight-bold">My Requests</h4>
            <span class="text-muted">Erp requests from previous months</span><br>
            <b v-if="loading"><img src="../assets/loader.gif"> Loading chart, please wait...</b> <br>

            <Charts></Charts>
            <!-- <canvas id="requests" width="100%" height="24px"/> -->
        </div>

    </div>
</template>

<script>
import Alerts from "@/components/Alerts";
import Charts from "@/components/Charts";
import CloseRequests from "@/components/CloseRequests.vue";

export default {
    name: "Dashboard",
    props: ['auth'],
    components: {CloseRequests, Alerts, Charts},
    data() {
        return {
            notifications: [],

            loading: false,
            stats: {
                notifications: 0,
                pending_requests: 0,
                approved_requests: 0,
                loans: 0
            }
        }
    },
    methods: {
        loadStats() {
            this.$http.get('stats').then(response => {
                this.stats = response.data.data
            }).catch(error => {
                this.showError(error)
            })
        }
    }
}
</script>

<style scoped>
.d-flex img {
    height: 48px !important;
}

.d-flex h1 {
    color: teal;
    font-size: 32px;
    font-family: "Righteous", sans-serif !important;
}

.notify:not(:last-child) {
    border-bottom: 1px dotted #ccc !important;
}

.dashboard {
    gap: 12px !important;
    flex-wrap: wrap;
}

@media only screen and (max-width: 480px) {
    .dashboard > div {
        flex: 40% !important;
    }
}
</style>
